module.exports = __webpack_public_path__ + "img/brand6-Photo.02944dba.png";